/** *
 * Helper service to construct conversation box structures.
 * The conversation data format should be a json array like so:
 * [
 *  {
 *    name: 'Name of User (Payer / Client / Admin)',
 *    type: 'admin' or 'client' or 'payer',
 *    timestamp: 'date timestamp',
 *    text: 'Body of the conversation text (non HTML)'
 *  }
 * ]
 */
app.service('conversationBoxService', [ 'CONSTANTS', 'portalHelper',
  function (CONSTANTS, portalHelper) {
    const service = this;
    service.USER_TYPE_ENUM = CONSTANTS.matUserTypes;

    /** *
     * Creates a thread for the conversation object
     * @param nameOfUser {string} Name of the User
     * @param timestamp {string} The timestamp of the post
     * @param typeOfUser {USER_TYPE_ENUM} The type of the user
     * @param text {string} The actual body of the comment
     * @return {{name, text, type, timestamp}}
     */
    service.createThread = function (nameOfUser, timestamp, typeOfUser, text) {
      return {
        name: nameOfUser,
        timestamp: timestamp,
        user_type: typeOfUser,
        text: text
      };
    };
  }
]);
